import { render, staticRenderFns } from "./ReportSearchBar.vue?vue&type=template&id=6061f47d"
import script from "./ReportSearchBar.vue?vue&type=script&lang=js"
export * from "./ReportSearchBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports